@import "../../../../shared/scss";

:host {
  display: block;

  phn-nd-menu-item {
    margin-block-start: p-px-to-rem(36px);

    &:first-of-type {
      margin-block-start: 0;
    }
  }
}
